"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
_moment.default.locale('pt-br');
var _default = exports.default = {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false,
      currentPage: 1
    };
  },
  computed: {
    processedData: function processedData() {
      var _this = this;
      return this.data.map(function (item) {
        return {
          employeeName: "".concat(item.user.firstName, " ").concat(item.user.lastName),
          title: item.shiftHours.title,
          startShift: _this.formatTime(item.shiftHours.start),
          endShift: _this.formatTime(item.shiftHours.end)
        };
      });
    }
  },
  methods: {
    formatTime: function formatTime(date) {
      return (0, _moment.default)(date).format('HH:mm:ss');
    }
  }
};